import { provideHttpClient, withXsrfConfiguration } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideZoneChangeDetection,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { FmntsBrowserModule } from '@fmnts/common/browser';
import {
  ConsoleLogDriver,
  provideLogDriver,
  provideLogging,
} from '@fmnts/common/log';
import { FmntsDefaultIconsLib } from '@fmnts/components/icons';
import { provideSharedDataAccess } from '@formunauts/shared/data-access';
import { provideSupporterFeedbackDataAccess } from '@formunauts/supporter-feedback/data-access';
import { provideMatomo } from 'ngx-matomo-client';
import { appRoutes } from './app.routes';
import { SupporterFeedbackAppConfig } from './supporter-feedback-app.config';
import { SupporterFeedbackLocalizationModule } from './supporter-feedback-l10n.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      FmntsBrowserModule,
      SupporterFeedbackLocalizationModule,
      FmntsDefaultIconsLib,
    ),
    provideHttpClient(
      withXsrfConfiguration({
        cookieName: 'csrftoken',
        headerName: 'X-CSRFToken',
      }),
    ),
    provideRouter(appRoutes),
    provideAppInitializer(() => {
      const initializerFn = (
        (config = inject(SupporterFeedbackAppConfig)) =>
        () =>
          config.init$()
      )();
      return initializerFn();
    }),
    provideSharedDataAccess(),
    provideLogging(),
    provideLogDriver(ConsoleLogDriver),
    provideSupporterFeedbackDataAccess(),
    provideMatomo({
      siteId: 0,
      trackerUrl: '',
      disabled: true,
    }),
  ],
};
